import { observer } from "mobx-react-lite";
import { FormWrapper } from "@/components/forms/FormWrapper";
import { useTranslation } from "react-i18next";
import { FormInput } from "@/components/forms/FormInput";
import { Card, CardContent } from "@/components/ui/card";
import { AuthenticationFormHeader } from "@/components/forms/AuthenticationFormHeader";
import { AuthenticationFormFooter } from "@/components/forms/AuthenticationFormFooter";
import { Routes } from "@/config/routes";
import { useForgotPassword } from "./useForgotPassword";
import { FormSubmitButton } from "@/components/forms/FormSubmitButton";

export const ForgotPassword = observer(() => {
	const { t } = useTranslation();
	const { form, onSubmit, showFormContent, error, loading } = useForgotPassword();
	return (
		<Card>
			<AuthenticationFormHeader
				title={showFormContent ? t("pages.forgot_password.title") : t("pages.forgot_password.success_title")}
				description={
					showFormContent
						? t("pages.forgot_password.explanation_text")
						: t("pages.forgot_password.success_explanation_text")
				}
			/>

			{showFormContent && (
				<CardContent>
					<FormWrapper form={form} onSubmit={onSubmit} error={error}>
						<FormInput
							required
							name="email"
							type="email"
							label={t("shared.forms.email.label")}
							placeholder={t("shared.forms.email.placeholder")}
						/>

						<FormSubmitButton
							isLoading={loading}
							buttonText={t("pages.forgot_password.button_text")}
							buttonLoadingText={t("pages.forgot_password.button_loading_text")}
						/>
					</FormWrapper>
				</CardContent>
			)}

			<AuthenticationFormFooter
				content={t("pages.forgot_password.remember_password_text")}
				link={{ linkTo: Routes.Auth.Login.path, linkText: t("pages.forgot_password.login_button_text") }}
			/>
		</Card>
	);
});
